var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.29 14.9999V13.4444C11.29 12.6193 10.9803 11.8279 10.4289 11.2445C9.87754 10.661 9.12974 10.3333 8.35 10.3333H3.94C3.16026 10.3333 2.41246 10.661 1.86111 11.2445C1.30975 11.8279 1 12.6193 1 13.4444V14.9999M11.29 1.09949C11.9205 1.27244 12.4788 1.66203 12.8774 2.20709C13.2759 2.75216 13.4922 3.42185 13.4922 4.11104C13.4922 4.80024 13.2759 5.46993 12.8774 6.01499C12.4788 6.56006 11.9205 6.94964 11.29 7.1226M15.7 14.9999V13.4444C15.6995 12.7551 15.4827 12.0854 15.0836 11.5406C14.6845 10.9958 14.1257 10.6067 13.495 10.4344",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14508 7.22222C7.7688 7.22222 9.08508 5.82933 9.08508 4.11111C9.08508 2.39289 7.7688 1 6.14508 1C4.52136 1 3.20508 2.39289 3.20508 4.11111C3.20508 5.82933 4.52136 7.22222 6.14508 7.22222Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUser);
export default __webpack_public_path__ + "static/media/TotalUser.9dec4c1d7a7cf6d584ded17f40cfb31d.svg";
export { ForwardRef as ReactComponent };